import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductResolver } from '../shared/route-guards/product-resolver';
import { ExcursionDetailComponent } from './excursion-detail/excursion-detail.component';
import { ExcursionsEditReviewsEditComponent } from './excursions-edit-reviews-edit/excursions-edit-reviews-edit.component';
//import { ExcursionsComponent } from './excursions/excursions.component';

const routes: Routes = [
	{ path: ':regionSlug/:destinationSlug/:slug', component: ExcursionDetailComponent, resolve: { product: ProductResolver } },
	//{ path: '', component: ExcursionsComponent },
	{ path: '', redirectTo: '/', pathMatch: 'full' },
	{ path: ':regionSlug/:destinationSlug/:slug/add-review', component: ExcursionsEditReviewsEditComponent, resolve: {product: ProductResolver}}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ExcursionRoutingModule { }
